import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import {ShowIf} from 'components/utils';
import { DuLieuHeThong } from 'api';

class DropDownChonDanToc extends React.Component {
  constructor(props, context) {
    super(props);
    this.state = {
      data: this.props.data
    }
  }

  componentDidMount() {
    if(this.props.data.length == 0) {
      DuLieuHeThong.actions.getDanToc.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'danToc',
            data: res.data && res.data._embedded && res.data._embedded.danTocs ? res.data._embedded.danTocs : []
          }]
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state})
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }


  render() {
    return (
      <ShowIf condition={this.props.quocTichID == 1}>
        <DropDown disabled={this.props.disabled} label="Dân tộc" options={ this.state.data } className={this.props.className} selectedValue={this.props.selectedValue} keyName='danTocId' valueName='ten' onChange={ this.onChange.bind(this) } placeholder={ this.props.placeholder } name="danToc" />
      </ShowIf>
    )
  }
}

DropDownChonDanToc.defaultProps = {
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  quocTichID: '',
  className: 'col-input',
  data: [],
  disabled: false
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.danToc
  }
}

export default connect(bindStateToProps)(DropDownChonDanToc);



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chondantoc.jsx